itsoftApp.createModule("view-360", function () {
    var module = this;

    var init360 = function () {
        itsoftApp.loadScript("/assets/scripts/js-cloudimage-360-view/js-cloudimage-360-view.min.js", function () {
            return;
        });
    }

    init360();

    module.callback = init360;
});